// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBookOutlinedSvg from "@fishx/icons-svg/es/asn/PBookOutlined";
import FishxIcon from '../components/FishxIcon';

var PBookOutlined = function PBookOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBookOutlinedSvg
  }));
};

PBookOutlined.displayName = 'PBookOutlined';
export default React.forwardRef(PBookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBookOutlined.js
// module id = 3239
// module chunks = 0